import angular from 'angular'
import {
    projectInfo
} from 'redevConfig'

const add = (projectInfo && projectInfo.add) || ''
const list = (projectInfo && projectInfo.list) || ''

const projectInfoListCtrl = list ? require(`redevelopment/outputManage/projectInfo/${list.controllerName}`) : require('./projectInfoListCtrl')
const editprojectInfoCtrl = add ? require(`redevelopment/outputManage/projectInfo/${add.controllerName}`) : require('./editprojectInfoCtrl')

const projectInfoListPage = list ? require(`redevelopment/outputManage/projectInfo/${list.templateName}`) : require('./views/projectInfoList.html')
const editprojectInfoPage = add ? require(`redevelopment/outputManage/projectInfo/${add.templateName}`) : require('./views/editprojectInfo.html')

function config($stateProvider) {
    $stateProvider
        .state('system.basedata.projectInfo', {
            url: '/projectInfo',
            template: '<div ui-view></div>',
            title: '项目信息',
            abstract: true,
            default: 'system.basedata.projectInfo.list',
        })
        .state('system.basedata.projectInfo.list', {
            url: '/list',
            controller: 'projectInfoListCtrl',
            template: projectInfoListPage,
        })
        .state('system.basedata.projectInfo.add', {
            url: '/add/:orgId',
            controller: 'editprojectInfoCtrl',
            template: editprojectInfoPage,
            title: '新增',
        })
        .state('system.basedata.projectInfo.edit', {
            url: '/edit/:projectId',
            controller: 'editprojectInfoCtrl',
            template: editprojectInfoPage,
            title: '编辑',
        })
}
export default angular
    .module('system.basedata.projectInfo', [])
    .config(['$stateProvider', config])
    .controller('projectInfoListCtrl', projectInfoListCtrl.default)
    .controller('editprojectInfoCtrl', editprojectInfoCtrl.default)
    .name


// WEBPACK FOOTER //
// ./src/app/system/basedata/projectInfo/index.js